import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    get(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/rboxes/" + id + "/"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get_boxes_by_barcode(barcode) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/boxes/?codebar=" + barcode
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/rboxes/" + id + "/report/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    createBox(params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/boxes/",
          data: { ...params }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    deleteBox(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "DELETE",
          url: API_BASE + `/boxes/${id}/`,
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
